import { PAGE_SET_TITLE } from '../actions/types';

const INITIAL_STATE = {
  title: '',
};

export const pageReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case PAGE_SET_TITLE:
      return {
        ...state,
        title: action.payload,
      };
    default:
      return state;
  }
};
